import { mapListToRecords } from '@sophocles/entities/entityUtils';
import { SmartlinkModel } from '@sophocles/entities/SmartlinkModel/smartlinkModelRecord';

/* REQUEST ACTIONS */
export const REQUEST_SMARTLINK_MODELS = 'REQUEST_SMARTLINK_MODELS'; // request all

/* RECEIVE ACTIONS */
export const RECEIVE_SMARTLINK_MODELS = 'RECEIVE_SMARTLINK_MODELS'; // plural receive
export function receiveSmartlinkModels(json) {
  return {
    type: RECEIVE_SMARTLINK_MODELS,
    smartlinkUnits: mapListToRecords(json, SmartlinkModel),
  };
}
